import { Game, MachinePublicHydrated } from "@aura-frontend/omnibus-az-client";
import { Button, Card, cn } from "@win-reality/react-ui";
import { Link, useParams } from "react-router-dom";

import decorativeArcs from "@/assets/decorative-arcs.svg";
import { ROUTES } from "@/lib/routes";
import { getScorekeepUrl } from "@/utils/scorekeepingUtils";

import { FieldCardEvent } from "../SingleComplex/FieldCardEvent";
import { FieldDevices } from "../SingleComplex/FieldDevices";

type ActiveEventProps = {
  machineField: MachinePublicHydrated;
  event: Game;
};

function ActiveEvent({ event, machineField }: ActiveEventProps) {
  const { complexName, fieldId } = useParams<{
    complexName: string;
    fieldId: string;
  }>();

  const editEventPath = ROUTES.EDIT_EVENT.replace(
    ":complexName",
    complexName ?? "",
  )
    .replace(":fieldId", fieldId ?? "")
    .replace(":eventId", machineField?.currentGame?.gameUuid ?? "");

  return (
    <div>
      {machineField?.extra?.field_cover && (
        <div
          className="h-37.5 bg-[#24252C] bg-cover bg-center relative rounded-t"
          style={{
            backgroundImage: machineField.extra.field_cover
              ? `url(${machineField.extra.field_cover})`
              : undefined,
          }}
        >
          <img
            src={decorativeArcs}
            alt=""
            className="pointer-events-none absolute -left-15 top-1/2 h-full -translate-y-1/2 opacity-30"
          />
        </div>
      )}
      <Card
        className={cn(machineField?.extra?.field_cover && "rounded-t-none")}
      >
        <Card className="shadow-glow-tiny hover:bg-blue/0! hover:shadow-glow-medium cursor-pointer transition-all">
          <Link to={editEventPath}>
            <FieldCardEvent field={machineField} event={event} />
          </Link>
        </Card>

        <div className="flex flex-col mt-4">
          {machineField && <FieldDevices machineField={machineField} />}
        </div>

        <div className="flex justify-end mt-4">
          <Link
            to={getScorekeepUrl(
              machineField.machineUuid,
              machineField.currentGame?.type,
            )}
          >
            <Button size="sm" variant="secondary-flat-light-outline">
              Scorekeep
            </Button>
          </Link>
        </div>
      </Card>
    </div>
  );
}

export { ActiveEvent };
